import { PersistConfig } from 'redux-persist';
import autoMergeLevel2 from 'redux-persist/es/stateReconciler/autoMergeLevel2';
import storage from 'redux-persist/es/storage'; // localStorage

import {
  activeCasesApi,
  aircraftStatusesApi,
  hubsResourceReportApi,
  newCasesApi,
  simpleStatisticsApi,
  surgeonsApi,
} from '../api';

import { migrate } from './migrations';

import type { WidgetManagerState } from '../widgetManager';
import type { RootState } from './rootReducer';

/**
 * Nested persister for widgetManager slice.
 * Excludes highlightedAircraftRegistration from persistence.
 */
export const widgetManagerPersistConfig: PersistConfig<WidgetManagerState> = {
  key: 'widgetManager',
  storage,
  blacklist: ['highlightedAircraftRegistration', 'highlightedAirports'],
};

/**
 * Root persist configuration with nested persisters.
 * If you need to exclude any slices, add them to blacklist.
 *
 * PERFORMANCE NOTE: We persist only essential user state (layout/widgets).
 * System templates are rebuilt on app start, reducing localStorage size.
 *
 * VERSION HISTORY:
 * - v1: Initial persist implementation
 * - v2: Reset layout state to fix widget ID mismatch on migration
 */
export const persistConfig: PersistConfig<RootState> = {
  key: 'root',
  version: 2,
  storage,
  stateReconciler: autoMergeLevel2,
  migrate,
  // whitelist: [], // persist everything by default
  blacklist: [
    'relations',
    'toolbar', // UI state, can be rebuilt
    'widgetManager', // Has its own nested persister
    activeCasesApi.reducerPath,
    aircraftStatusesApi.reducerPath,
    hubsResourceReportApi.reducerPath,
    newCasesApi.reducerPath,
    simpleStatisticsApi.reducerPath,
    surgeonsApi.reducerPath,
  ], // add slice names here to NOT persist them
};
